import { Timestamp, TranslateFunction, WeekDays } from '@griply/types';

import { getScheduleLabel } from './get-schedule-label';
import { completeRruleFromStartDate } from './schedules/complete-rrule-from-start-date';
import { isValidRrule } from './schedules/parse-rrule';
import { parseRruleAndCountToSchedule } from './schedules/parse-rrule-and-count-to-schedule';

// An instance's rule lives on the master, so null is "nothing to say", not "does not repeat".
export const getCalendarEventRepeatLabel = (
  rrule: string | null,
  startDate: Timestamp,
  t: TranslateFunction,
  weekStartsOn?: WeekDays,
): string | null => {
  if (!rrule) {
    return null;
  }

  // provider-authored rules reach here: shapes our builder never emits throw or mislabel
  try {
    const completed = completeRruleFromStartDate(rrule, startDate);

    if (!isValidRrule(completed, { hasCount: true })) {
      return null;
    }

    return getScheduleLabel(
      parseRruleAndCountToSchedule(completed, null, startDate),
      t,
      true,
      weekStartsOn,
    );
  } catch {
    return null;
  }
};
